// @flow
import React, { useContext } from 'react'
import { Icons, Button, FlexRow, FlexCol, Stack, Text } from 'sarsaparilla'
import { type Moment } from 'moment'

import { LayoutControlContext } from './DetailedAvailabilityPageLayout'

const MonthYearTitle = ({ startDate, endDate, isMobileApp }: {startDate: Moment, endDate: Moment, isMobileApp: boolean}) => {
    let monthYearTitle = '';

    const startMonth = startDate.format('MMM');
    const endMonth = endDate.format('MMM');

    if (startDate.isSame(endDate)) {
        monthYearTitle = startDate.format('DD MMM YYYY');
    }
    else if (startMonth === endMonth) {
        monthYearTitle = `${startMonth} ${startDate.format('YYYY')}`;
    }
    else {
        monthYearTitle = `${startMonth} / ${endMonth} ${startDate.format('YYYY')}`;
    }

    return (
        <Text size={isMobileApp ? "lg" : "xl"} fontWeight="semibold" style={{textTransform: "uppercase"}}>{monthYearTitle}</Text>
    );
}

type PropTypes = {
    onClearSelection?: () => ?any,
    onNextAvailable?: () => ?any,
    onNext?: () => ?any,
    onPrev?: () => ?any,

    nextText?: string,
    prevText?: string,

    isPrevDisabled?: boolean,

    startDate: Moment,
    endDate: Moment,
    
}
export default function DetailedAvailabilityNavigator({
    onClearSelection,
    onNextAvailable,
    onNext,
    onPrev,

    nextText = 'Next 5 Days',
    prevText = 'Prev 5 Days',
    
    isPrevDisabled = false,
    hasNextAvailableDate = true,

    startDate,
    endDate,
    
}: PropTypes) {
    const {
        isMobileApp,
    } = useContext(LayoutControlContext);

    return (
        <Stack>
            <FlexRow alignItems="center" className="mb-1 mr-0">
                <FlexCol alignSelf="start">
                    <MonthYearTitle startDate={startDate} endDate={endDate} isMobileApp={isMobileApp} />
                </FlexCol>
                {(!!onClearSelection && !isMobileApp) && (
                    <FlexCol xs="variable">
                        <Button
                            size="xs"
                            appearance="link"
                            onClick={onClearSelection}
                            iconBeforeElement={<Icons.IconCloseCircleOutline />}
                            screenReaderTextAfter="that were selected" >
                            Clear Dates
                        </Button>
                    </FlexCol>
                )}
                {!!onNextAvailable && hasNextAvailableDate && (
                    <FlexCol xs="variable">
                        <Button
                            size="xs"
                            className="ml-1"
                            appearance="tertiary"
                            onClick={onNextAvailable}
                            screenReaderTextBefore="Go to"
                            screenReaderTextAfter="dates" >
                            Next Available
                        </Button>
                    </FlexCol>
                )}
                {!!onPrev && (
                    <FlexCol xs="variable">
                        <Button
                            size="xs"
                            className="ml-1"
                            appearance="tertiary-alt"
                            onClick={onPrev}
                            isDisabled={isPrevDisabled}
                            iconBeforeElement={<Icons.IconChevronLeft />}
                            screenReaderTextBefore="View" >
                            {!isMobileApp && prevText}
                        </Button>
                    </FlexCol>
                )}
                {!!onNext && (
                    <FlexCol xs="variable">
                        <Button
                            size="xs"
                            className="ml-1"
                            appearance="tertiary-alt"
                            onClick={onNext}
                            iconAfterElement={<Icons.IconChevronRight />}
                            screenReaderTextBefore="View" >
                            {!isMobileApp && nextText}
                        </Button>
                    </FlexCol>
                )}
            </FlexRow>
        </Stack>
    );
}
